<template>
    <div class="page-wrapper section-space--inner--120">
        <!--Contact section start-->
        <div class="conact-section">
            <div class="container">

                <div class="row section-space--bottom--20">
                    <div class="col">
                        <!-- google map component -->
                        <GoogleMap src="https://www.google.com/maps/embed/v1/place
                        ?key=AIzaSyDBkn5RoHaEPVkWJjRLHc-XzBCXBN_DuRs
                        &origin=place_id:ChIJk6RAcnVBkFQREPixJlzeUSg"/>

                    </div>
                </div>
                <p class="section-space--bottom--20">We service the greater Seattle Area. Including Kirkland, Bothell, Edmunds, Lynwood, and Tukwila.</p>
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="contact-information">
                            <h3>{{ data.contactInfo.title }}</h3>
                            <ul>
                                <li>
                                    <span class="icon">
                                        <i :class="data.contactInfo.address.icon"></i>
                                    </span>
                                    <span class="text">
                                        {{ data.contactInfo.address.location }}
                                    </span>
                                </li>
                                <li>
                                    <span class="icon">
                                        <i :class="data.contactInfo.telephone.icon"></i>
                                    </span>
                                    <span class="text">
                                        <a href="tel:123456789">{{ data.contactInfo.telephone.no_1 }}</a>
                                        <a href="tel:123456789">{{ data.contactInfo.telephone.no_1 }}</a>
                                    </span>
                                </li>
                                <li>
                                    <span class="icon"><i :class="data.contactInfo.mail.icon"></i></span>
                                    <span class="text">
                                        <a href="mailto:infor@example.com">{{ data.contactInfo.mail.email }}</a>
                                        <a href="#">{{ data.contactInfo.mail.web }}</a>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-8 col-12">
                        <div class="contact-form">
                            <h3>Leave Your Message</h3>
<!--                            action="https://r9mxwqx0wg.execute-api.us-west-2.amazonaws.com/nextstep_email" method="GET"-->
                            <form id="contact-form" @submit.prevent="handleSubmit">
                                <div class="row row-10">
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input v-model="name" type="text" required="required"  placeholder="Your Name">
                                    </div>
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input v-model="email" type="email" required="required"  placeholder="Your Email">
                                    </div>
                                    <div class="col-12">
                                        <textarea v-model="message" required="required"  placeholder="Your Message"></textarea>
                                    </div>
                                    <div class="col-12">
                                        <button>Send Message</button>
                                    </div>
                                </div>
                            </form>
                            <p class="form-message"></p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!--Contact section end-->
    </div>
</template>

<script>
    import data from '../../data/contact.json'
    import GoogleMap from '@/components/GoogleMap';
    import axios from 'axios'
    export default {
        components: {
            GoogleMap,
        },
        data () {
            return {
                data,
                name: "",
                email:"",
                message:""
            }
        },
        methods : {
            handleSubmit : function() {
                axios.get('https://r9mxwqx0wg.execute-api.us-west-2.amazonaws.com/nextstep_email', {
                    params: {
                        'name': this.name,
                        'email': this.email,
                        'message': this.message
                    }
                }).then(response => {
                    // TODO: For some reason we don't trigger this despite the request succeding
                    alert('Message submitted')
                    window.location.reload();
                }).catch(error => {
                    alert('Message submitted')
                    window.location.reload();
                });
            }
        }
    };
</script>